import {StyleSheet} from "aphrodite";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

// eslint-disable-next-line @khan/frontend/require-shared-package-imports-only -- porting from old code.
import {tabletMax} from "~/marketing-content-shared-package/media-queries.ts";

export const sharedStyles = StyleSheet.create({
    shrunkenIcon: {
        width: 32,
        height: 32,
        margin: 0,
        marginBlockEnd: -spacing.small_12,
    },
    messageBubble: {
        padding: `${spacing.xSmall_8}px ${spacing.medium_16}px`,
        width: "fit-content",
        minBlockSize: "fit-content",
        borderRadius: 8,
        maxWidth: `min(100%, ${tabletMax})`,
    },
    botMessageTeacherAsStudentMode: {
        backgroundColor: color.fadedBlue8,
    },
    outerWrapper: {
        display: "flex",
        flexDirection: "row",
        listStyle: "none",
    },
    wcagAAATargetSize: {
        width: 44,
        height: 44,
    },
    wcagAATargetSize: {
        width: 24,
        height: 24,
    },
});
